(function (global) {
  function getLabels() {
    return {
      pause:
        (global.accessibilityStrings && global.accessibilityStrings.pauseSlideshow) ||
        'Pause slideshow',
      play:
        (global.accessibilityStrings && global.accessibilityStrings.playSlideshow) ||
        'Play slideshow',
    };
  }

  function bindAutoplayToggle(swiper, button) {
    if (!swiper || !button || !swiper.params || !swiper.params.autoplay) return;

    var labels = getLabels();
    button.setAttribute('aria-label', labels.pause);
    button.setAttribute('aria-pressed', 'true');

    button.addEventListener('click', function () {
      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
        button.classList.add('swiper-autoplay-toggle--paused');
        button.setAttribute('aria-label', labels.play);
        button.setAttribute('aria-pressed', 'false');
      } else {
        swiper.autoplay.start();
        button.classList.remove('swiper-autoplay-toggle--paused');
        button.setAttribute('aria-label', labels.pause);
        button.setAttribute('aria-pressed', 'true');
      }
    });
  }

  function bindSectionAutoplayToggle(section, getSwipers, button) {
    if (!section || !button) return;

    var labels = getLabels();
    var paused = false;

    button.setAttribute('aria-label', labels.pause);
    button.setAttribute('aria-pressed', 'true');

    button.addEventListener('click', function () {
      paused = !paused;
      var swipers = typeof getSwipers === 'function' ? getSwipers() : [];

      swipers.forEach(function (swiper) {
        if (!swiper || !swiper.params || !swiper.params.autoplay) return;
        if (paused) swiper.autoplay.stop();
        else swiper.autoplay.start();
      });

      button.classList.toggle('swiper-autoplay-toggle--paused', paused);
      button.setAttribute('aria-label', paused ? labels.play : labels.pause);
      button.setAttribute('aria-pressed', paused ? 'false' : 'true');
      section.dataset.autoplayPaused = paused ? 'true' : 'false';
    });
  }

  global.SwiperA11y = {
    bindAutoplayToggle: bindAutoplayToggle,
    bindSectionAutoplayToggle: bindSectionAutoplayToggle,
  };
})(window);
